import { storeToRefs } from "pinia";
import LxcError from "~/core/models/LxcError.class";
import type { UseFetchParameters } from "~/core/models/UseFetchParameters.interface";
import type { License } from "~/modules/license/models/License.interface";
import licenseService from "~/modules/license/services/license.service";
import { useLicenseStore } from "~/modules/license/stores/useLicenseStore";

export function useFetchActiveLicenseInformation({
  organizationCode,
}: UseFetchParameters) {
  const { setActiveLicenseInformationAndError } = useLicenseStore();
  const { activeLicenseInformation, activeLicenseError } =
    storeToRefs(useLicenseStore());

  const result = ref<License | undefined>();
  const isLoading = ref(false);
  const error = ref<LxcError | undefined>();

  async function fetchActiveLicenseInformation(refresh?: boolean) {
    isLoading.value = true;
    if (
      refresh ||
      !activeLicenseInformation.value ||
      activeLicenseError.value
    ) {
      const response =
        await licenseService.getActiveLicenseInformation(organizationCode);

      if (LxcError.check(response)) {
        error.value = response;
        result.value = undefined;
      } else {
        error.value = undefined;
        result.value = response;
      }
      setActiveLicenseInformationAndError({
        license: result.value,
        error: error.value,
      });
    } else {
      result.value = activeLicenseInformation.value;
    }
    isLoading.value = false;
  }

  return {
    isLoading,
    result,
    error,
    fetchActiveLicenseInformation,
  };
}
